import { useState } from "react";
import type { ShiftFormApprovalScheduleSettings } from "../../../shared/shift-production-form/contracts";

type Props = {
  settings: ShiftFormApprovalScheduleSettings;
  busy: boolean;
  onSave: (sendTime: string, expectedVersion: number) => Promise<void>;
};

export function ApprovalMailScheduleForm({ settings, busy, onSave }: Props) {
  const [sendTime, setSendTime] = useState(settings.sendTime);
  return <form className="shift-mail-schedule-form" onSubmit={event => { event.preventDefault(); void onSave(sendTime, settings.version); }}>
    <h3>Günlük onay e-postası</h3>
    <p>Önceki günün bekleyen formları ve daha eski bekleyenler bu saatte gönderilir. Saat dilimi: Türkiye (İstanbul).</p>
    <div className="shift-mail-schedule-controls">
      <label className="shift-form-field"><span>Gönderim saati</span><input type="time" required value={sendTime} disabled={busy} onChange={event => setSendTime(event.target.value)} /></label>
      <button className="shift-form-primary" type="submit" disabled={busy || sendTime === settings.sendTime}>{busy ? "Kaydediliyor…" : "Saati kaydet"}</button>
    </div>
  </form>;
}
